<template>
  <div class="animated fadeIn">
    <b-card size="sm">
      <div slot="header">
        <i class="icon-note"></i> SPKB Detail
      </div>

      <b-card-body>
        <div>
          <b-form id="spkbForm" validated novalidate>
            <div v-if="!loading">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="spkb_number" label="SPKB Number">
                    <b-form-input
                      id="spkb_number"
                      type="text"
                      v-model="spkbForm.spkb_number"
                      readonly
                    ></b-form-input>
                    <b-form-invalid-feedback>SPKB Number harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="driver" label="Driver">
                    <b-form-select
                      id="driver"
                      :options="listDriverEmployee"
                      v-model="$v.spkbForm.driver.$model"
                      :state="!$v.spkbForm.driver.$invalid"
                      @input="selectInvoicePic($event, 'driver')"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Driver harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="delivery_date" label="Tanggal Pengiriman">
                    <v-date-picker
                      id="delivery_date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Pengiriman', required: ''}"
                      :state="!$v.spkbForm.delivery_date.$invalid"
                      v-model="$v.spkbForm.delivery_date.$model"
                    ></v-date-picker>
                    <div
                      v-if="$v.spkbForm.delivery_date.$invalid"
                      class="invalid-feedback-custom"
                    >Tanggal pengiriman harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="delivery_to" label="Tujuan Pengiriman">
                    <b-form-select
                      id="delivery_to"
                      :options="listSendTo"
                      @change="sendToChange($event)"
                      v-model="$v.spkbForm.delivery_to.$model"
                      :state="!$v.spkbForm.delivery_to.$invalid"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Tujuan pengiriman harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col sm="3" v-if="show_dc">
                  <b-form-group label-for="send_to_dc" label="Distribution Center">
                    <b-form-select
                      id="send_to_dc"
                      v-model="$v.spkbForm.send_to_dc.$model"
                      :state="!$v.spkbForm.send_to_dc.$invalid"
                      @input="selectInvoicePic($event, 'dc')"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>

                      <option
                        v-for="(item, index) in listDistributionCenter"
                        :key="index"
                        :value="{value:item.dc_code, dc_id: item.value}"
                      >{{item.text}}</option>
                    </b-form-select>
                    <b-form-invalid-feedback>Distribution center harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="invoice_pic" label="Penanggung Jawab Faktur">
                    <b-form-select
                      id="invoice_pic"
                      v-model="$v.spkbForm.invoice_pic.$model"
                      :state="!$v.spkbForm.invoice_pic.$invalid"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                      <option
                        v-for="(item, index) in listDriverEmployee"
                        :key="uniqueId('employee_list'+index)"
                        :value="{code:'employee', value:item.value}"
                      >{{item.text}}</option>
                      <option
                        v-for="(item, index) in listDistributionCenter"
                        :key="uniqueId('dc_list'+index)"
                        :value="{code:'distribution_center', value:item.value}"
                      >{{item.text}}</option>
                    </b-form-select>
                    <b-form-invalid-feedback>Penanggung jawab faktur harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <!-- <b-col sm="3">
                   <b-form-group label-for="spkb_type" label="Tipe SPKB">
                    <model-select
                      id="spkb_type"
                      :options="listSpkbType"
                      v-model="$v.spkbForm.spkb_type.$model"
                      :isError="$v.spkbForm.spkb_type.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="spkbForm.spkb_type === null"
                      class="invalid-feedback-custom"
                    >SPKB Type harus di isi.</div>
                  </b-form-group>
                </b-col> -->
              </b-row>

              <b-row>
                 <b-col sm="3">
                  <b-form-group label-for="notes" label="Catatan">
                    <b-form-textarea
                      id="notes"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.spkbForm.notes.$model"
                      :state="!$v.spkbForm.notes.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Catatan harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="editOrder"
                  :disabled="$v.spkbForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-body>
        <b-row>
          <b-col sm="12">
            <global-table
              :table-data="spkbOrder"
              :loading="loading"
              :per-page="10"
              :table-detail="tableDetail"
              :bordered="true"
              :hover="true"
              :striped="false"
              :id-modals="'spkbDetailForm'"
              :row-edit="spkbDetailForm"
              :redirect-detail="false"
              :show-add-button="removeButton"
              :edit-button="false"
              :remove-button="removeButton"
              :fields="fieldsSpkbDetail"
              addButton="SPKB Order"
              @editForm="editForm"
              @resetForm="resetForm"
              @removeForm="removeForm"
            ></global-table>

            <b-modal
              ref="myModalDetailRef"
              id="spkbDetailForm"
              header-border-variant="no-border text-center"
              footer-border-variant="no-border"
              footer-bg-variant="light"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              size="lg"
            >
              <div slot="modal-header" class="text-center">
                <h3 class="text-center">Input order ke SPKB</h3>
              </div>

              <b-form id="spkbDetailForm" validated novalidate>
                <div v-if="!loadingSubmitModal">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group label-for="order_number" label="Order Number">
                        <model-select
                          id="zone"
                          :options="listOrderNumber"
                          v-model="$v.spkbDetailForm.order_number.$model"
                          :state="!$v.spkbDetailForm.order_number.$invalid"
                          @input="showOrder"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                        v-if="spkbDetailForm.order_number === null"
                          class="invalid-feedback-custom"
                        >Order number harus di pilih.</div>
                        <!-- <b-form-select
                          id="order_number"
                          :options="listOrderNumber"
                          v-model="$v.spkbDetailForm.order_number.$model"
                          :state="!$v.spkbDetailForm.order_number.$invalid"
                          @change="showOrder"
                          required
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Harap pilih salah satu --</option>
                          </template>
                        </b-form-select>
                        <b-form-invalid-feedback>Order number harus di pilih.</b-form-invalid-feedback> -->
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <global-table
                        :table-data="listShowOrder"
                        :loading="loading"
                        :per-page="10"
                        :table-detail="tableDetail"
                        :bordered="true"
                        :hover="true"
                        :striped="false"
                        :id-modals="'a'"
                        :redirect-detail="false"
                        :show-add-button="false"
                        :remove-button="false"
                        :fields="fieldShowOrder"
                        :pagination="false"
                        addButton
                      ></global-table>
                    </b-col>
                    <b-col sm="12">
                      <global-table
                        :table-data="listShowOrderDetail"
                        :loading="loading"
                        :per-page="5"
                        :table-detail="tableDetail"
                        :bordered="true"
                        :hover="true"
                        :striped="false"
                        :id-modals="'a'"
                        :redirect-detail="false"
                        :show-add-button="false"
                        :remove-button="false"
                        :fields="fieldShowOrderDetail"
                        addButton
                      ></global-table>
                    </b-col>
                  </b-row>
                </div>
                <div v-else>
                  <loading></loading>
                </div>
              </b-form>

              <div slot="modal-footer" class="float-right">
                <div v-if="!loadingSubmitModal">
                  <b-button type="button" size="sm" variant="danger" @click="cancelSaveSpkb">
                    <i class="fa fa-undo"></i> Back
                  </b-button>&nbsp;
                  <b-button
                    type="button"
                    size="sm"
                    variant="primary"
                    @click="saveSpkbDetail"
                    :disabled="$v.spkbDetailForm.$invalid"
                  >
                    <i class="fa fa-save"></i> Save
                  </b-button>
                </div>
              </div>
            </b-modal>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required } from "vuelidate/lib/validators";
import globalTable from "../../templates/Table.vue";
import loading from "@/templates/Loading.vue";
import _ from "lodash";

export default {
  name: "spkb_detail",
  components: {
    globalTable,
    ModelSelect,
    loading
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      spkb: [],
      spkbOrder: [],
      listDriverEmployee: [],
      listDistributionCenter: [],
      listOrderNumber: [],
      listShowOrder: [],
      listShowOrderDetail: [],
      listSpkbType: [],
      listSendTo: [
        { value: "1", text: "Dikirim Ke DC" },
        { value: "2", text: "Lainnya" },
        { value: "3", text: "Horeka" }
      ],
      loading: true,
      loadingSubmitModal: false,
      show_dc: false,
      removeButton: false,
      spkbForm: interfaces.spkb,
      spkbDetailForm: interfaces.spkb_order,
      fieldsSpkbDetail: [
        { key: "order_number", sortable: true },
        { key: "customer_name", label: "Nama Konsumen" },
        { key: "qty_total_order", label: "Jumlah Pesanan" },
        { key: "total_price_plan", label: "Jumlah Order" },
        { key: "employee_name", label: "Di input oleh" },
        { key: "date_order", label: "Tanggal Order" },
        { key: "action", class: "text-center width-80" }
      ],
      fieldShowOrder: [
        { key: "customer_name", label: "Nama Konsumen" },
        { key: "employee_name", label: "Di input oleh" },
        { key: "date_order", label: "Tanggal Order" }
      ],
      fieldShowOrderDetail: [
        { key: "product_name", label: "Nama Produk" },
        { key: "qty_total_order", label: "Jumlah Pesanan" },
        { key: "price_plan", label: "Harga Per-Box" },
        { key: "total_price_plan", label: "Jumlah Order" }
      ]
    };
  },
  validations() {
    if (this.show_dc) {
      return custom_validation.spkb_detail_form.true;
    } else {
      return custom_validation.spkb_detail_form.false;
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function(spkb_id) {
      this.loading = true;
      this.getDetailSpkb(spkb_id);
      this.getDropdownSpkb();
    },
    getDetailSpkb: function(spkb_id) {
      this.axios
        .get("web/spkb/detail/" + spkb_id + "/")
        .then(response => {
          this.spkbForm = response.data.spkb;
          this.spkbForm.delivery_date =
            this.spkbForm.delivery_date !== null
              ? new Date(this.spkbForm.delivery_date)
              : null;
          if (this.spkbForm.send_to_dc !== null) {
            this.spkbForm.delivery_to = "1";
            this.show_dc = true;
            this.spkbForm.send_to_dc = {
              value: this.spkbForm.send_to_dc,
              dc_id: this.spkbForm.dc_id
            };
          } else {
            this.spkbForm.delivery_to = "2";
            this.show_dc = false;
            this.spkbForm.send_to_dc = null;
          }

          if (this.spkbForm.invoice_pic_employee !== null) {
            this.spkbForm.invoice_pic = {
              code: "employee",
              value: this.spkbForm.invoice_pic_employee
            };
          } else {
            this.spkbForm.invoice_pic = {
              code: "distribution_center",
              value: this.spkbForm.invoice_pic_dc
            };
          }
          let division = localStorage.getItem('division_id');
          let nik = localStorage.getItem('nik');
          this.removeButton = (response.data.ignore_division.includes(division)) ? true: false;
          if(response.data.spkb.status === "2") {
             this.removeButton = false;
          }
          
          // employee allow remove button
          if(response.data.allow_user.includes(nik)) {
             this.removeButton = true;
          }
          this.spkbOrder = response.data.spkb_order;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    getDropdownSpkb: function() {
      //this.loading = true;
      this.axios
        .get("web/dropdown/dropdown-spkb/")
        .then(response => {
          this.listDriverEmployee = response.data.driver;
          this.listDistributionCenter = response.data.distribution_center;
          this.listOrderNumber = response.data.orders;
          this.listSpkbType = response.data.spkb_type;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    back: function() {
      this.$router.go(-1);
    },
    sendToChange: function(event) {
      this.spkbForm.send_to_dc = null;
      this.spkbForm.delivery_to = event;
      if (event === "1") {
        this.show_dc = true;
        this.spkbForm.invoice_pic = null;
      } else {
        this.show_dc = false;
        this.spkbForm.invoice_pic = (this.spkbForm.driver !== null) ? { code: "employee", value: this.spkbForm.driver } : null;
      }
    },
    editOrder: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin mengubah SPKB ?")) {
        this.axios
          .put("web/spkb/change-spkb/", this.spkbForm)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Ubah SPKB",
                message: response.data.message
              });
            }
            //this.cancelSaveSpkb();
          })
          .catch(error => {
            this.expired(error, "Ubah SPKB");
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
      // console.log(this.spkbForm);
      // let route = this.$route.path.split("/");
    },
    editForm: function(a) {
      this.resetForm();
      this.spkbDetailForm = a;
      this.spkbDetailForm.isEdit = 1;
    },
    removeForm: function(data) {
      if (confirm("Apakah anda ingin menghapus order ini ?")) {
        this.axios
          .delete(
            "web/spkb/remove-detail/" +
              data.spkb_order_detail_id +
              "/" +
              data.order_id
          )
          .then(response => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Hapus Detail SPKB",
              message: response.data.message
            });
          })
          .catch(error => {
            this.expired(error, "Hapus Detail SPKB");
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    resetForm: function() {
      for (var a in interfaces.spkb_order) {
        interfaces.spkb_order[a] = null;
      }
      this.spkbDetailForm = interfaces.spkb_order;
    },
    saveSpkbDetail: function(evt) {
      evt.preventDefault();

      if (confirm("Apakah anda ingin menambahkan order ini ?")) {
        this.loadingSubmitModal = true;
        let spkb_detail = this.spkbDetailForm;
        spkb_detail.spkb_number = this.spkbForm.spkb_number;
        this.axios
          .post("web/spkb/add-detail/", spkb_detail)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah SPKB Detail",
                message: response.data.message
              });
            } else {
               this.showErrorNotification({
                title: "Tambah SPKB Detail",
                message: response.data.message
              });
            }
            this.cancelSaveSpkb();
          })
          .catch(error => {
            this.expired(error, "Tambah SPKB Detail");
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    cancelSaveSpkb: function() {
      this.$refs.myModalDetailRef.hide();
      this.listShowOrder = [];
      this.listShowOrderDetail = [];
    },
    showOrder: function(event) {
      this.axios
        .get("web/order/order-by/" + event)
        .then(response => {
          this.listShowOrder = response.data.order;
          this.listShowOrderDetail = response.data.order_detail;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    selectInvoicePic: function(event, flag) {
      this.spkbForm.invoice_pic = null;
      if (flag === "driver") {
        if (this.spkbForm.delivery_to === "2") {
          this.spkbForm.invoice_pic = { code: "employee", value: event };
        }
      } else if (flag === "dc") {
        if (this.spkbForm.delivery_to === "1") {
          this.spkbForm.invoice_pic = { code: "distribution_center", value: event.dc_id };
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>